import { Spin } from 'antd';
import { Loading3QuartersOutlined } from '@ant-design/icons';


const CustomSpin = ({size=24,color='#adb5bd'})=>{
    const customIcon = <Loading3QuartersOutlined  style={{ fontSize: size, color:color }} spin />;
    return(<Spin indicator={customIcon} />)
}

export default CustomSpin
